import { Badge } from '@chakra-ui/react';
import type { InvoiceStatus } from '../../types/invoice';
import { INVOICE_LIST_STATUS_META } from './invoiceListStatusConfig';

export interface InvoiceListStatusBadgeProps {
    status: InvoiceStatus;
}

/** Status pill used on the invoices list table—matches modal examples. */
export function InvoiceListStatusBadge({ status }: InvoiceListStatusBadgeProps) {
    const { colorScheme } = INVOICE_LIST_STATUS_META[status];
    return (
        <Badge
            colorScheme={colorScheme}
            variant="subtle"
            px={2}
            py={1}
            fontSize="xs"
            fontWeight="medium"
            whiteSpace="normal"
            lineHeight="tight"
            textAlign="center"
        >
            {status === 'manually_submitted' ? (
                <>
                    MANUALLY
                    <br />
                    SUBMITTED
                </>
            ) : (
                status.toUpperCase()
            )}
        </Badge>
    );
}
